
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
    selector: 'lib-admin-toolbar',
    imports: [MatToolbarModule, MatIconModule, MatButtonModule],
    template: `
    <mat-toolbar color="primary">
      @if(showToggle()){
      <button mat-icon-button (click)="toggleSidenav.emit()">
        <mat-icon>menu</mat-icon>
      </button>
      }
      <span class="spacer"></span>
      <ng-content />
    </mat-toolbar>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./admin-toolbar.component.scss']
})
export class AdminToolbarComponent {
  showToggle = input(true);
  readonly toggleSidenav = output<void>();
  readonly toggleSidenavNotice = output<void>();
}
